<template>
  <div class="direct-document">
    <div class="bold tac mb-20">{{ direct.organization__name }}</div>
    <table class="mb-20">
      <tr>
        <td colspan="2">
          <div class="bold tac">
            {{ direct.register_book__name }}-NAZORAT KARTOCHKASI<br>
            {{ direct.type__name }}
          </div>
          <div class="mt-10 tac">
            {{ direct.original_document_date }}dagi № {{ direct.original_document_number }}<br>
            Tashkilotga kelib tushgan sana {{ direct.registered_date }}<br>
            Ro’yxatdat o’tkazish raqami {{ direct.registration_number }}
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="bold">HUJJATNING NOMI: {{ direct.description }}</div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="bold">RAHBARNING RESOLYUTSIYASI:</div>
          <div class="mb-10">
            <template v-if="direct.resolution ">{{ direct.resolution }}</template>
            <template v-else>Ijrosi ta’minlansin</template>
          </div>
          <div v-for="t in direct.resolution_tasks">
            {{ t.description }}, mas’ul: {{ t.employee.fullname }}
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="level">
            <div class="level-left">{{ direct.resolution_approver__post_name }}</div>
            <div class="level-right">{{ direct.resolution_approver__initials }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td width="50%">
          <div class="bold">Mas’ul xodimlar:</div>
          <div class="mb-10">{{ direct.resolution_maintainer__initials }} muddati: {{ direct.resolution_term_date }}
          </div>
          <div v-for="t in direct.resolution_tasks">
            {{ t.employee.fullname }}: {{ t.description }}, muddat: {{ t.term_date }}
          </div>
        </td>
        <td>
          <div class="bold">Muddati:</div>
          <div>{{ direct.resolution_term_date }}</div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="mb-50">QABUL QILINGAN QAROR:</div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div>NAZORAT BANDLARI:</div>
          <div v-for="plan_group in direct.plan_groups">
            {{ plan_group.order_number }}.{{ plan_group.name }}
            <div v-for="plan_item in plan_group.plan_items">
              {{ plan_group.order_number }}.{{ plan_item.order_number }} {{ plan_item.name }}
            </div>
          </div>
          <div v-for="plan_item in direct.plan_items">
            {{ plan_item.order_number }} {{ plan_item.name }}
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Nazorat uchun ma’sul:<br>
          {{ direct.supervisor__initials }}<br>
          Axborot berish muddati: {{ direct.plan_items_min_term_date }}
        </td>
        <td>
          Bajaruvchilar:<br>
          <template v-for="plan_group in direct.plan_groups">
            <div v-for="plan_item in plan_group.plan_items">
              {{ plan_item.maintainer.name }}, muddati: {{ plan_item.term_date }}
            </div>
          </template>
          <div v-for="plan_item in direct.plan_items">
            {{ plan_item.maintainer.name }}, muddati: {{ plan_item.term_date }}
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Hujjatlarni berish:
          <table class="mt-5">
            <tr class="tac">
              <td>Hujjatni olgan shaxsning FISh</td>
              <td>Imzo</td>
              <td>Sana</td>
              <td>Vaqti</td>
            </tr>
            <tr v-for="(c, n) in direct.correspondents">
              <td>{{n+1}}. {{ c.name }}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <table>
      <tr>
        <td>
          <div class="tac mb-10">ISH YURITILISHI</div>
          <div class="big-space">NAZORAT BANDLARI BO’YICHA</div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="mb-20">
            NAZORATDAN OLINDI<br>
            (qachon, kim, qaysi hujjat asosida)
          </div>
          <div class="big-space">
            SANA: {{ direct.closed_date }}
            {{ direct.closing_report }}
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="mb-15">
            {{ direct.closed_employee__initials_and_post_name }}
          </div>
          <div class="level mb-50">
            <div class="level-left">Imzo:</div>
            <div class="level-right">{{ direct.closed_date }}</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState('Docflow', ['direct'])
    }
  }
</script>

<style lang="scss" scoped>
  .direct-document {
    font-size: 16px;
    line-height: 28px;

    h1 {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 30px;

      .sub {
        font-size: 16px;
      }
    }

    table {
      width: 100%;
      margin-bottom: 20px;
      border: 1px solid #000;
      line-height: 120%;

      tr {
        td {
          padding: 10px 16px;
          border: 1px solid #000;
        }
      }
    }

    .bold {
      font-weight: bold;
    }

    .tac {
      text-align: center;
    }

    .underline {
      text-decoration: underline;
    }

    ul {
      list-style: disc;

      li {
        margin-left: 18px;
      }
    }

    .big-space {
      margin-bottom: 180px;
    }
  }
</style>
